module.exports = __webpack_public_path__ + "static/media/portada_Cap3_CANIMOLT.1abeb2d5.jpg";